import { Controller } from "@hotwired/stimulus";

/**
 * A short buzz when a form carrying `data-haptic` starts submitting, on browsers
 * with the Vibration API (Android Chrome). Where it is missing — iOS Safari,
 * Firefox — this does nothing. `turbo:submit-start` fires only once a
 * `data-turbo-confirm` is accepted, so declining a confirm never buzzes, and it
 * fires before the request goes out, so the buzz answers the tap, not the save.
 */
export default class HapticController extends Controller<HTMLElement> {
  static readonly DURATION_MS = 20;

  tap(event: Event) {
    if (!(event.target instanceof HTMLFormElement) || !event.target.hasAttribute("data-haptic")) return;
    if ("vibrate" in navigator) navigator.vibrate(HapticController.DURATION_MS);
  }
}
